import { PropInfo, CodeExample, BreadcrumbItemProps, BreadcrumbsProps } from '@cimpress/react-components';
import React, { Fragment } from 'react';

import ComponentDoc from '../../shared/TabbedComponentDoc';

import BreadcrumbsCode from '!raw-loader!./breadcrumbs.jsx';
import BreadcrumbsDemo from './breadcrumbs.jsx';

export default function BreadcrumbsDocs() {
  const breadcrumbPropInfos: PropInfo<BreadcrumbsProps>[] = [
    {
      name: 'children',
      type: 'node',
      default: '',
      description: 'The individual breadcrumbs to be rendered.',
    },
  ];

  const breadcrumbItemPropInfos: PropInfo<BreadcrumbItemProps>[] = [
    {
      name: 'active',
      type: 'bool',
      default: '',
      description: 'Whether or not the breadcrumb is active.',
    },
    {
      name: 'children',
      type: 'node',
      default: '',
      description: 'The inner contents of the component.',
    },
  ];

  return (
    <Fragment>
      <ComponentDoc<BreadcrumbsProps> name="Breadcrumbs" propInfos={breadcrumbPropInfos} />
      <ComponentDoc<BreadcrumbItemProps> includeTabs={false} name="BreadcrumbItem" propInfos={breadcrumbItemPropInfos}>
        <BreadcrumbsDemo />
        <CodeExample code={BreadcrumbsCode} />
      </ComponentDoc>
    </Fragment>
  );
}
